import { useState } from 'react';
import { splitRoles } from '../helpers';
function TonalitySection({ role, tonality, setTonality }) {
  const hasVoice = splitRoles(role).includes("Voce");
  if (!hasVoice) return null;
  const KEYS = ["Do","Do#","Re","Re#","Mi","Fa","Fa#","Sol","Sol#","La","La#","Si"];
  const [mode,setMode] = useState(()=>{
    if(!tonality||tonality==="originale")return"originale";
    if(tonality==="più alta"||tonality==="più bassa")return"altezza";
    if(/^[+-]?\d+\s*semitoni$/.test(tonality))return"semitoni";
    return"tonalita";
  });
  const getSemitoni=()=>{const m=tonality?.match(/^([+-]?\d+)\s*semitoni$/);return m?parseInt(m[1]):0;};
  const setM=(m)=>{setMode(m);if(m==="originale")setTonality("originale");else if(m==="altezza")setTonality("più alta");else if(m==="semitoni")setTonality("0 semitoni");else setTonality("");};
  return (
    <div style={{background:"rgba(237,77,29,0.08)",border:"1px solid rgba(237,77,29,0.3)",borderRadius:10,padding:"12px 14px",marginBottom:14}}>
      <div style={{fontSize:16,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".8px",marginBottom:9}}>Tonalità voce</div>
      <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:10}}>
        {[["originale","Originale"],["altezza","Più alta/bassa"],["semitoni","Semitoni"],["tonalita","Tonalità"]].map(([v,l])=>(
          <span key={v} className={`chip ${mode===v?"selected":""}`} style={{fontSize:16}} onClick={()=>setM(v)}>{l}</span>
        ))}
      </div>
      {mode==="originale"&&<div style={{fontSize:16,color:"var(--muted)"}}>Canto nella tonalità originale.</div>}
      {mode==="altezza"&&<div style={{display:"flex",gap:7}}>
        {[["più alta","Più alta"],["più bassa","Più bassa"]].map(([v,l])=>(
          <button key={v} className={`btn btn-sm ${tonality===v?"btn-primary":"btn-secondary"}`} onClick={()=>setTonality(v)}>{l}</button>
        ))}
      </div>}
      {mode==="semitoni"&&<div style={{display:"flex",gap:7,alignItems:"center"}}>
        <button className="btn btn-sm btn-secondary" onClick={()=>setTonality(`${getSemitoni()-1} semitoni`)}>−</button>
        <span style={{fontFamily:"'DM Mono',monospace",fontSize:16,minWidth:85,textAlign:"center"}}>{getSemitoni()>0?`+${getSemitoni()}`:getSemitoni()} semitoni</span>
        <button className="btn btn-sm btn-secondary" onClick={()=>setTonality(`${getSemitoni()+1} semitoni`)}>+</button>
      </div>}
      {mode==="tonalita"&&<div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>{KEYS.map(k=><span key={k} className={`chip ${tonality===k||tonality===k+"m"?"selected":""}`} style={{fontSize:16}} onClick={()=>setTonality(k)}>{k}</span>)}</div>
        <div style={{display:"flex",gap:7,marginTop:7}}>
          <button className={`btn btn-xs ${tonality&&!tonality.endsWith("m")?"btn-primary":"btn-secondary"}`} onClick={()=>setTonality(t=>t?.replace("m","")||"")}>Maggiore</button>
          <button className={`btn btn-xs ${tonality?.endsWith("m")?"btn-primary":"btn-secondary"}`} onClick={()=>setTonality(t=>t&&!t.endsWith("m")?t+"m":t)}>Minore</button>
        </div>
      </div>}
    </div>
  );
}


export default TonalitySection;
